import {
  DataTableQueryFnParams,
  PricingSheet,
  PricingSheetState,
  TableFilterOptions,
  TableWithPaginationDataResponse,
} from ".";

export enum ArchiveReason {
  ExpiredRenewedAsNewSheet = "Hinnasto vanhentui - uusitaan tekemällä uusi hinnasto",
  ExpiredNoRenew = "Hinnasto vanhentui - ei uusita, ei saavuta tavotteita",
  RedundantReplica = "Hinnasto tehty tuplana tai uusi versio",
  CustomerNoLead = "Hinnasto ei johtanut asiakkuuteen",
  Renewal = "Jatkettu voimassaoloa",
  CustomerRejectionPrice = "Asiakas hylkäsi hinnaston - Liian kallis",
  CustomerRejectionProduct = "Asiakas hylkäsi hinnaston - Vääränlainen kalusto",
  SalesManagerReject = "Myyntipäällikkö ei hyväksynyt",
  TestPricingSheet = "Testihinnasto",
  Other = "Muu syy, mikä?",
}

export type ArchiveReasonKeys = keyof typeof ArchiveReason;

export type PricingSheetTableData = Omit<PricingSheet, "id"> & {
  id: number;
  createdAt: Date;
};

export enum RentalHistorySourceType {
  Customer = "Customer",
  CompanyChain = "CompanyChain",
}

// filter option types
export type GetPricingSheetsTableFilterOptions = TableFilterOptions<
  PricingSheetTableData,
  {
    byUser?: boolean;
    validTo?: string;
    archived?: boolean;
    shared?: boolean;
    includeStates: PricingSheetState[];
  }
>;

// get pricing sheets
export type GetPricingSheetsRequestParams = Record<string, unknown>;
export type GetPricingSheetsResponseBody = TableWithPaginationDataResponse<
  PricingSheet[]
>;
export type GetPricingSheetsRequestQueryParams<FilterType = string> =
  DataTableQueryFnParams<PricingSheet, FilterType>;
